import React from 'react';
import BankTransferNotice from './BankTransferNotice';
import BankTransferDetails from './BankTransferDetails';
import BankTransferContact from './BankTransferContact';

const BankTransferInterface = ({ importeDeuda, divisa, formatAmount, isLoading, error }) => {
  return (
    <div className='max-w-lg mx-auto px-4 py-8'>
      {/* Card payment unavailable notice */}
      <BankTransferNotice />

      {/* Debt summary */}
      <div className='bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden mb-6'>
        <div className='p-6'>
          <h2 className='text-lg font-semibold text-slate-900 mb-2'>Tu deuda pendiente</h2>
          <div className='flex items-baseline justify-between'>
            <span className='text-slate-600'>Importe total</span>
            <span className='text-2xl font-bold text-slate-900'>
              {isLoading && 'Cargando…'}
              {!isLoading && error && '—'}
              {!isLoading && !error && formatAmount(importeDeuda, divisa)}
            </span>
          </div>
          <p className='mt-3 text-sm text-slate-500'>
            El importe exacto de tu deuda se muestra en la comunicación que has recibido. Si tienes dudas, contáctanos.
          </p>
          {!isLoading && error && (
            <p className='mt-3 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3'>{error}</p>
          )}
        </div>
      </div>

      {/* Bank transfer details */}
      <BankTransferDetails />

      {/* Contact */}
      <BankTransferContact />
    </div>
  );
};

export default BankTransferInterface;
